// extracted by mini-css-extract-plugin
export default {"app":"App_app__wsp6j","words":"App_words__Wmafu","wrapper":"App_wrapper__Nbir9"};